import { command, serviceCommands } from '@estee/elc-service-bus';

export class ProductAddedUseCase {
    private skuId: string;
    private quantity: number;
    private replenishment: number;

    constructor(skuId: string, quantity: number = 1, replenishment?: number) {
        this.skuId = skuId;
        this.quantity = quantity;
        if (replenishment) {
            this.replenishment = replenishment;
        }
    }
    public execute = async () => {
        const { skuId, quantity, replenishment } = this;

        if (replenishment) {
            await command(serviceCommands.CART_ADD_ITEM, { skuId, quantity, replenishment });
        } else {
            await command(serviceCommands.CART_ADD_ITEM, { skuId, quantity });
        }

        await command(serviceCommands.CART_OVERLAY_SHOW);
    };
}
